module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-317934d8.png";